const MapArrData = [
  [require('./images/az.svg'), 'Azerbaijan'],
  [require('./images/ba.svg'), 'Bosnia and Herzegovina'],
  // [require('./images/bb.svg'), 'Barbados'],
  [require('./images/bd.svg'), 'Bangladesh'],
  [require('./images/be.svg'), 'Belgium'],
  [require('./images/bf.svg'), 'Burkina Faso'],
  [require('./images/bg.svg'), 'Bulgaria'],
  // [require('./images/bh.svg'), 'Bahrain'],
  [require('./images/bi.svg'), 'Burundi'],
  [require('./images/bj.svg'), 'Benin'],
  //  [require("./images/bl.svg") , "Saint Barthélemy"], // Official Flag is France
  // [require('./images/bm.svg'), 'Bermuda'],
  // [require('./images/bm.svg'), 'Brunei'],
  [require('./images/bo.svg'), 'Bolivia'],
  //  [require("./images/bq.svg") , "Caribbean Netherlands"],
  [require('./images/br.svg'), 'Brazil'],
  // [require('./images/bs.svg'), 'Bahamas'],
  [require('./images/bt.svg'), 'Bhutan'],
  //[require("./images/bv.svg") , "Bouvet Islands"], // Same Flag as Norway
  [require('./images/bw.svg'), 'Botswana'],
  [require('./images/by.svg'), 'Belarus'],
  [require('./images/bz.svg'), 'Belize'],
  [require('./images/ca.svg'), 'Canada'],
  // [require('./images/cc.svg'), 'Cocos Islands'],
  [require('./images/cd.svg'), 'DR Congo'],
  [require('./images/cf.svg'), 'Central African Republic'],
  [require('./images/cg.svg'), 'Republic of Congo'],
  [require('./images/ch.svg'), 'Switzerland'],
  [require('./images/ci.svg'), "Côte d'Ivoire"],
  // [require('./images/ck.svg'), 'Cook Islands'],
  [require('./images/cl.svg'), 'Chile'],
  [require('./images/cm.svg'), 'Cameroon'],
  [require('./images/cn.svg'), 'China'],
  [require('./images/co.svg'), 'Colombia'],
  [require('./images/cr.svg'), 'Costa Rica'],
  [require('./images/cu.svg'), 'Cuba'],
  // [require('./images/cv.svg'), 'Cape Verde'],
  // [require('./images/cw.svg'), 'Curaçao'],
  // [require('./images/cx.svg'), 'Christmas Island'],
  [require('./images/cy.svg'), 'Cyprus'],
  [require('./images/cz.svg'), 'Czechia'],
  [require('./images/de.svg'), 'Germany'],
  [require('./images/dj.svg'), 'Djibouti'],
  [require('./images/dk.svg'), 'Denmark'],
  // [require('./images/dm.svg'), 'Dominica'],
  [require('./images/do.svg'), 'Dominican Republic'],
  [require('./images/dz.svg'), 'Algeria'],
  [require('./images/ec.svg'), 'Ecuador'],
  [require('./images/ee.svg'), 'Estonia'],
  [require('./images/eg.svg'), 'Egypt'],
  [require('./images/eh.svg'), 'Western Sahara'],
  [require('./images/er.svg'), 'Eriteria'],
  [require('./images/es.svg'), 'Spain'],
  [require('./images/et.svg'), 'Ethiopia'],
  [require('./images/fi.svg'), 'Finland'],
  // [require('./images/fj.svg'), 'Fiji'],
  [require('./images/fk.svg'), 'Falkland Islands'],
  // [require('./images/fm.svg'), 'Micronesia'],
  // [require('./images/fo.svg'), 'Faroe Islands'],
  [require('./images/fr.svg'), 'France'],
  [require('./images/ga.svg'), 'Gabon'],
  // [require('./images/gb-eng.svg'), 'England'],
  // [require('./images/gb_nir.svg'), 'Northern Ireland'],
  // [require('./images/gb-sct.svg'), 'Scotland'],
  // [require('./images/gb_wls.svg'), 'Wales'],
  [require('./images/gb.svg'), 'Great Britian'],
  // [require('./images/gd.svg'), 'Grenada'],
  [require('./images/ge.svg'), 'Georgia'],
  [require('./images/gf.svg'), 'French Guiana'],
  // [require('./images/gg.svg'), 'Guernsey'],
  [require('./images/gh.svg'), 'Ghana'],
  // [require('./images/gi.svg'), 'Gibraltar'],
  [require('./images/gl.svg'), 'Greenland'],
  [require('./images/gm.svg'), 'Gambia'],
  [require('./images/gn.svg'), 'Guinea'],

  [require('./images/gq.svg'), 'Equatorial Guinea'],
  [require('./images/gr.svg'), 'Greece'],

  [require('./images/gt.svg'), 'Guatemala'],
  // [require('./images/gu.svg'), 'Guam'],
  [require('./images/gw.svg'), 'Guinea Bissau'],
  [require('./images/gy.svg'), 'Guyana'],
  // [require('./images/hk.svg'), 'Hong Kong'],

  [require('./images/hn.svg'), 'Honduras'],
  [require('./images/hr.svg'), 'Croatia'],
  [require('./images/ht.svg'), 'Haiti'],
  [require('./images/hu.svg'), 'Hungary'],
  [require('./images/id.svg'), 'Indonesia'],
  [require('./images/ie.svg'), 'Ireland'],
  [require('./images/il.svg'), 'Israel'],
  // [require('./images/im.svg'), 'Isle of Man'],
  [require('./images/in.svg'), 'India'],
  // [require('./images/io.svg'), 'British Indian Ocean Territory'],
  [require('./images/iq.svg'), 'Iraq'],
  [require('./images/ir.svg'), 'Iran'],
  [require('./images/is.svg'), 'Iceland'],
  [require('./images/it.svg'), 'Italy'],
  // [require('./images/je.svg'), 'Jersey'],
  [require('./images/jm.svg'), 'Jamaica'],
  [require('./images/jo.svg'), 'Jordan'],
  [require('./images/jp.svg'), 'Japan'],
  [require('./images/ke.svg'), 'Kenya'],
  [require('./images/kg.svg'), 'Kyrgyzstan'],
  [require('./images/kh.svg'), 'Cambodia'],
  // [require('./images/ki.svg'), 'Kiribati'],
  // [require('./images/km.svg'), 'Comoros'],
  [require('./images/kp.svg'), 'North Korea'],
  [require('./images/kr.svg'), 'South Korea'],
  [require('./images/kw.svg'), 'Kuwait'],
  // [require('./images/ky.svg'), 'Cayman Islands'],
  [require('./images/kz.svg'), 'Kazakhstan'],
  [require('./images/la.svg'), 'Laos'],
  [require('./images/lb.svg'), 'Lebanon'],
  // [require('./images/lc.svg'), 'Saint Lucia'],
  // [require('./images/li.svg'), 'Liechtenstein'],
  [require('./images/lk.svg'), 'Sri Lanka'],
  [require('./images/lr.svg'), 'Liberia'],
  [require('./images/ls.svg'), 'Lesotho'],
  [require('./images/lt.svg'), 'Lithuania'],
  [require('./images/lu.svg'), 'Luxembourg'],
  [require('./images/lv.svg'), 'Latvia'],
  [require('./images/ly.svg'), 'Libya'],
  [require('./images/ma.svg'), 'Morocco'],
  // [require('./images/mc.svg'), 'Monaco'],
  [require('./images/md.svg'), 'Moldova'],
  [require('./images/me.svg'), 'Montenegro'],

  [require('./images/mg.svg'), 'Madagascar'],
  // [require('./images/mh.svg'), 'Marshall Islands'],
  [require('./images/mk.svg'), 'North Macedonia'],
  [require('./images/ml.svg'), 'Mali'],
  [require('./images/mm.svg'), 'Myanmar'],
  [require('./images/mn.svg'), 'Mongolia'],
  // [require('./images/mo.svg'), 'Macau'],
  // [require('./images/mp.svg'), 'Northern Mariana Islands'],
  [require('./images/mr.svg'), 'Mauritania'],
  // [require('./images/ms.svg'), 'Montserrat'],
  // [require('./images/mt.svg'), 'Malta'],
  // [require('./images/mu.svg'), 'Mauritius'],
  // [require('./images/mv.svg'), 'Maldives'],
  [require('./images/mw.svg'), 'Malawi'],
  [require('./images/mx.svg'), 'Mexico'],
  [require('./images/my.svg'), 'Malaysia'],
  [require('./images/mz.svg'), 'Mozambique'],
  [require('./images/na.svg'), 'Namibia'],
  [require('./images/ne.svg'), 'Niger'],

  [require('./images/ng.svg'), 'Nigeria'],
  [require('./images/ni.svg'), 'Nicaragua'],
  [require('./images/nl.svg'), 'Netherlands'],
  [require('./images/no.svg'), 'Norway'],
  [require('./images/np.svg'), 'Nepal'],

  [require('./images/nz.svg'), 'New Zealand'],
  [require('./images/om.svg'), 'Oman'],
  [require('./images/pa.svg'), 'Panama'],
  [require('./images/pe.svg'), 'Peru'],

  [require('./images/pg.svg'), 'Papua New Guinea'],
  [require('./images/ph.svg'), 'Philippines'],
  [require('./images/pk.svg'), 'Pakistan'],
  [require('./images/pl.svg'), 'Poland'],
  [require('./images/ps.svg'), 'Palestine'],
  [require('./images/pt.svg'), 'Portugal'],

  [require('./images/py.svg'), 'Paraguay'],
  [require('./images/qa.svg'), 'Qatar'],
  [require('./images/ro.svg'), 'Romania'],
  [require('./images/rs.svg'), 'Serbia'],
  [require('./images/ru.svg'), 'Russia'],
  [require('./images/rw.svg'), 'Rwanda'],
  [require('./images/sa.svg'), 'Saudi Arabia'],

  [require('./images/sd.svg'), 'Sudan'],
  [require('./images/se.svg'), 'Sweden'],
  [require('./images/si.svg'), 'Slovenia'],

  [require('./images/sk.svg'), 'Slovakia'],
  [require('./images/sl.svg'), 'Sierra Leone'],

  [require('./images/sn.svg'), 'Senegal'],
  [require('./images/so.svg'), 'Somalia'],
  [require('./images/sr.svg'), 'Suriname'],
  [require('./images/ss.svg'), 'South Sudan'],
  [require('./images/sv.svg'), 'El Salvador'],
  [require('./images/sy.svg'), 'Syria'],
  [require('./images/sz.svg'), 'Eswatini'],
  [require('./images/td.svg'), 'Chad'],
  [require('./images/tg.svg'), 'Togo'],
  [require('./images/th.svg'), 'Thailand'],
  [require('./images/tj.svg'), 'Tajikstan'],
  [require('./images/tm.svg'), 'Turkmenistan'],
  [require('./images/tn.svg'), 'Tunisia'],

  [require('./images/tr.svg'), 'Turkey'],

  [require('./images/tw.svg'), 'Taiwan'],
  [require('./images/tz.svg'), 'Tanzania'],
  [require('./images/ug.svg'), 'Uganda'],
  [require('./images/ua.svg'), 'Ukraine'],

  [require('./images/us.svg'), 'United States'],
  [require('./images/uy.svg'), 'Uruguay'],
  [require('./images/uz.svg'), 'Uzbekistan'],
  [require('./images/ve.svg'), 'Venezuela'],

  [require('./images/vn.svg'), 'Vietnam'],

  [require('./images/xk.svg'), 'Kosovo'],
  [require('./images/ye.svg'), 'Yemen'],

  [require('./images/za.svg'), 'South Africa'],
  [require('./images/zm.svg'), 'Zambia'],
  [require('./images/zw.svg'), 'Zimbabwe'],
];
export default MapArrData;
